import React, { useEffect, useState } from "react";
import { Collapse } from "reactstrap";
import queryStirng from "query-string";

import { useHistory } from "react-router-dom";
import ExchangeBtn from "components/starshop/exchangeModal/ExchangeBtn";

import arrow_star_up from "styles/common/img/starshop/arrow_star_up.png";
import arrow_star_down from "styles/common/img/starshop/arrow_star_down.png";

const ExchangeBody = (props) => {
    const { myInfo, exchangable } = props;

    const history = useHistory();

    const search = history.location.search;
    const { image, title, point, rewardCode } = queryStirng.parse(search);

    const [isOpen, setIsOpen] = useState(true);
    const [checked, setChecked] = useState(false);

    const [inpt1, setInpt1] = useState("");
    const [inpt2, setInpt2] = useState("");
    const [inpt3, setInpt3] = useState("");

    const [disabled, setDisabled] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    //const passTargetArr = useSelector((state)=>state.starshopReducer.passTargetArr);
    //const targetInfo = useSelector((state)=>state.starshopReducer.targetInfo);

    //const img = image.substring(2);
    const number = inpt1 + inpt2 + inpt3;

    useEffect(() => {
        if (inpt1.length > 3) {
            setInpt1("");
        } else {
            if (inpt2.length > 4) {
                setInpt2("");
            } else if (inpt3.length > 4) {
                setInpt3("");
            }
        }
    }, [number]);

    const numberArr = {
        arr1: inpt1,
        arr2: inpt2,
        arr3: inpt3,
    };

    useEffect(() => {
        setDisabled(false);
        if (inpt1 !== "" && inpt2 !== "" && inpt3 !== "") {
            setDisabled(true);
        }
    }, [number]);

    // let arr = [];
    // for(var obj in targetInfo){
    //     arr[obj] = targetInfo[obj]
    // };
    // for(var obj in passTargetArr){
    //     arr[obj] = passTargetArr[obj]
    // };

    const handleChx = (e) => {
        setChecked(e.target.checked);
    };

    return (
        <>
            <div className="">
                {" "}
                {/* 2021-01-14 pt60 클래스명 삭제 */}
                <div className="starPopup_InfoWrap">
                    <div className="star_wrap">
                        <ul className="star_left">
                            {/* 목표 상품 있을 경우 노출 */}
                            <li className="star_goal">
                                <div className="img">
                                    <div className="centered">
                                        <img src={`http://down.wjthinkbig.com/STARSHOP/DAOU/${image}`} />
                                    </div>
                                </div>
                                <div className="txt">
                                    <p className="brand">나의 목표</p>
                                    <p className="goods">{title}</p>
                                </div>
                            </li>
                            <li className="star_goal_btn_wrap">
                                <div className="star_goal_btn">
                                    <p className="num">{point}개</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="star_popupbody">
                    <ul>
                        <li className="star_popup_cellnum">
                            <ul>
                                <p className="fl">선물 받을 번호</p>
                                <div className="fl">
                                    <div className="cell_wrap">
                                        <input
                                            type="number"
                                            id="ipt1"
                                            value={inpt1}
                                            onChange={(e) => setInpt1(e.currentTarget.value)}
                                            className="fl input"
                                        />
                                        <div className="numline fl"></div>
                                        <input
                                            type="number"
                                            id="ipt2"
                                            value={inpt2}
                                            onChange={(e) => setInpt2(e.currentTarget.value)}
                                            className="fl"
                                        />
                                        <div className="numline fl"></div>
                                        <input
                                            type="number"
                                            id="ipt3"
                                            value={inpt3}
                                            onChange={(e) => setInpt3(e.currentTarget.value)}
                                            className="fl"
                                        />
                                    </div>
                                </div>
                            </ul>
                        </li>
                        <li className="Info">
                            <ul>
                                <li className="check_wrap">
                                    <div className="orange-txt fl">[필수] 개인정보 취급 위탁에 대한 동의</div>
                                    <div className="checkbox-container fr">
                                        <input type="checkbox" id="is-subscription" onChange={handleChx} />
                                        <label for="is-subscription">
                                            <span>동의합니다.</span>
                                        </label>
                                    </div>
                                </li>
                                <li className="cell_wrap">- 수탁자 :주식회사 웅진씽크빅/주식회사 다우기술</li>
                                <li className="cell_wrap">- 목적 : 모바일 기프티콘 발송</li>
                                <li className="cell_wrap">- 항목 : 휴대폰 번호</li>
                                <li className="cell_wrap">- 보유 및 이용기간 : 신청 시점 ~ 계약종료시까지</li>
                            </ul>
                        </li>
                        <li className="star_popup_cellnum" onClick={toggle}>
                            <ul>
                                <p className="fl">교환 전 확인 하세요!</p>
                                {isOpen ? (
                                    <img src={arrow_star_up} className="fr star_arrow_up" />
                                ) : (
                                    <img src={arrow_star_down} className="fr star_arrow_down " />
                                )}
                            </ul>
                        </li>
                        <Collapse isOpen={isOpen} className="innerInfoWrap">
                            <ul className="inner-info">
                                {/* 20201224 수정 */}
                                <li className="red-text">
                                    ※ 한 번 발송된 선물은 취소가 불가하니 번호를 정확하게 확인해주세요.
                                </li>
                                <li>※ 개인정보 취급 위탁에 동의하지 않은 경우 선물이 발송되지 않습니다.</li>
                                <li>※ 선물은 유효기간까지 꼭 사용하셔야 합니다.</li>
                                <li>
                                    ※ 선물 재발송은 불가하며 번호를 잘못 입력한 경우에는 고객센터 1577-1500으로
                                    문의바랍니다.
                                </li>
                            </ul>
                        </Collapse>
                    </ul>
                </div>
                <ExchangeBtn
                    checked={checked}
                    disabled={disabled}
                    phoneNumber={numberArr}
                    myInfo={myInfo}
                    targetCode={rewardCode}
                    exchangable={exchangable}
                />
            </div>
        </>
    );
};

export default ExchangeBody;
